export const masonryOpts: MasonryOptsInterface = {
	responsive: true,
	breakpointCols: {
		"min-width: 769px": 3,
		"min-width: 481px": 2,
	},
	numCols: 3,
};

/**
 * List of e.key values that should be checked on keyup event.
 *
 * @var string[]
 */
export const keyupKeys: string[] = [
	"a",
	"b",
	"c",
	"d",
	"e",
	"f",
	"g",
	"h",
	"i",
	"j",
	"k",
	"l",
	"m",
	"n",
	"o",
	"p",
	"q",
	"r",
	"s",
	"t",
	"u",
	"v",
	"w",
	"x",
	"y",
	"z",
	"0",
	"1",
	"2",
	"3",
	"4",
	"5",
	"6",
	"7",
	"8",
	"9",
	" ",
	"spacebar",
	"delete",
	"backspace",
	"-",
	"_",
	"@",
	".",
	"/",
];
